import React, { useMemo, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { Form, Popconfirm, notification, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import DF from 'DisplayFramework';
import { indexBy, toDatePickerDate } from 'utils/utils2';
import Button from 'components/Button';
import DataGrid from 'components/DataGrid/DataGrid';
import ParListSelect from 'components/ParListSelect';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  getServiceListByCriteria,
  GetServiceListByCriteriaParams,
  ParServiceResponse,
  removeService,
} from 'services/pricing';
import ServiceStatusButton from './components/ServiceStatusButton';
import DeleteButton from 'components/DeleteButton';
import { Link, useHistory } from 'react-router-dom';
// import { ParServiceSearchModalProps } from '../ParEnvironment/ParEnvironementDetail/components/ParServiceSearchModal';
import ThirdPartyInput from 'components/ThirdPartyInput';
import ModalControllerNV from 'components/ModalControllerNV';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';

const NEW_SERVICE_ID = '-1';
// type Values = {
//   pricing: ParServiceResponse[];
//   visible: boolean;
//   onCancel: () => void;
//   hideServiceModal?: () => void;
//   onServiceSelect: (page: ParServiceResponse) => void;
//   hideAddButton: boolean;
//   hideActionsButton?: boolean;
// };
export type ParServiceSearchModalProps ={
  visible?: boolean,
  onCancel?: () => void,
  hideServiceModal?: () => void,
  onServiceSelect?: (page: ParServiceResponse) => void
  hideAddButton?: boolean;
  hideActionsButton?: boolean;
  tpid?: number; 
};
const ServiceListTable = (props: ParServiceSearchModalProps) => {
  const { onCancel, onServiceSelect, hideAddButton, hideActionsButton,tpid } = props;
  const [form] = Form.useForm();
  const fieldName = 'service';
  const history = useHistory();
  const [isfirst, setIsFirst] = useState<boolean>(false);
  const initialSearchParams: GetServiceListByCriteriaParams = {
    servcode: '',
    servlabel: '',
    servstatus: '',
    servtype: '',
    servcategory: '',
    tpidsupplier: tpid ?? 0,
  };

  const [searchParams, setSearchParams] =
    useState<GetServiceListByCriteriaParams>(initialSearchParams);

  const { data, refetch, isFetching } = useQuery(
    ['getServiceListByCriteria', searchParams],
    () => getServiceListByCriteria(searchParams).then((res) => res.list || []),
    { refetchOnMount: false, enabled: isfirst }
  );

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        [fieldName]: data.map((service: ParServiceResponse) => ({
          ...service,
          startdate: toDatePickerDate(service.startdate),
          enddate: toDatePickerDate(service.enddate),
          thirdparty: {
            tpid: service.tpidsupplier,
            tpname: service.tpname,
            tpreference: service.tpreference,
          },
        })),
      });
    } else {
      form.setFieldsValue({
        [fieldName]: [],
      });
    }
  }, [form, data]);

  const columns = useMemo<DataGridColDef<ParServiceResponse>[]>(
    () => [
      {
        dataIndex: 'servcode',
        filtrable: true,
        width: 70,
        render: (_value, _record, index) =>
          onServiceSelect ? (
            <Typography.Link
              onClick={() => {
                onServiceSelect(_record);
                onCancel &&  onCancel();
              }}
            >
              {_value}
            </Typography.Link>
          ) : (
            <Link to={`/configuration/service/${_record.servcode}`}>
              {_value}
            </Link>
          ),
      },
      {
        dataIndex: 'servlabel',
        filtrable: true,
        render: (_value, _record, index) =>
          onServiceSelect ? (
            <Typography.Link
              onClick={() => {
                onServiceSelect(_record);
                onCancel && onCancel();
              }}
            >
              {_value}
            </Typography.Link>
          ) : (
            <Form.Item
              name={[
                fieldName,
                indexBy(form.getFieldValue(fieldName), 'servcode')[
                  _record.servcode
                ],
                'servlabel',
              ]}
            >
              <Link to={`/configuration/service/${_record.servcode}`}>
                {_value}
              </Link>
            </Form.Item>
          ),
        width: 250,
      },
      {
        dataIndex: 'servtype',
        comcode: 'servtypelabel',
        filtrable: true,
        filterComponent: <ParListSelect parcode="SERVTYPE" allowClear />,
        render: (_value, _record, index) => {
          return (
            <Form.Item
              name={[
                fieldName,
                indexBy(form.getFieldValue(fieldName), 'servcode')[
                  _record.servcode
                ],
                'servtypelabel',
              ]}
            >
              {_record.servtypelabel}
            </Form.Item>
          );
        },
        width: 150,
      },
      // {
      //   dataIndex: 'servcategory',
      //   comcode: 'servcategorylabel',
      //   filtrable: true,
      //   filterComponent: <ParListSelect parcode="SERVCAT" allowClear />,
      //   render: (_value, _record, index) => {
      //     return (
      //       <Form.Item
      //         name={[
      //           fieldName,
      //           indexBy(form.getFieldValue(fieldName), 'servcode')[
      //             _record.servcode
      //           ],
      //           'servcategorylabel',
      //         ]}
      //       >
      //         {_record.servcategorylabel}
      //       </Form.Item>
      //     );
      //   },
      //   width: 240,
      // },
      {
        dataIndex: 'servcategory',
        comcode: 'servcategorylabel',
        filtrable: true,
        filterComponent: <ParListSelect parcode="SERVCAT" allowClear />,
        render: (_value, _record, index) => {
          return (
            <Form.Item
              name={[
                fieldName,
                indexBy(form.getFieldValue(fieldName), 'servcode')[
                  _record.servcode
                ],
                'servcategorylabel',
              ]}
            >
              {_record.servcategorylabel}
            </Form.Item>
          );
        },
        width: 220,
      },
      {
        dataIndex: 'tpreference',
        comcode: 'tpreference',
        filtrable: 'tpidsupplier',
        filterComponent: <ThirdPartyInput onlytpid parcodeRole="TPSERVROLE" />,
        width: 160,
        fixed: 'right',
        render: (_value, _record) => {
          return (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {_record.tpname}
                </a>
              )}
              modal={({ setVisible, visible }) => (
                <ThirdPartyModal
                  tpId={_record.tpidsupplier}
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  onSuccess={() => setVisible(false)}
                  title={_record.tpname}
                  iscreate={false}
                />
              )}
            />
          );
        },
      },
      {
        dataIndex: 'servbasis',
        comcode: 'servbasislabel',
        render: (_value, _record, index) => (
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) => (
              <Form.Item
                name={[
                  fieldName,
                  indexBy(getFieldValue(fieldName), 'servcode')[
                    _record.servcode
                  ],
                  'servbasislabel',
                ]}
                rules={[{ required: true }]}
              >
                {_record.servbasislabel}
              </Form.Item>
            )}
          </Form.Item>
        ),
        width: 200,
      },

      {
        width: 160,
        fixed: 'right',
        dataIndex: 'actions',
        comcode: 'actions',
        render: (_, _record) => (
          <>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => {
                removeService({
                  servcode: _record.servcode,
                }).then((res) => {
                  notification.success({ message: res.message });
                  refetch();
                });
              }}
            >
              <DeleteButton onlyIcon />
            </Popconfirm>
            <ServiceStatusButton
              refetch={refetch}
              servcode={_record.servcode}
              status={_record.servstatus}
            />
          </>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form, refetch]
  );

  return (
    <DF.Provider pagcode="serviceList">
      <Form form={form} initialValues={INITIAL_VALUES}>
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) => {
            const service: ParServiceResponse[] = getFieldValue(fieldName);
            const isNewItemInTable =
              service?.find(({ servcode }) => servcode === NEW_SERVICE_ID) !==
              undefined;

            return (
              <DataGrid
                rowKey="servcode"
                componentName="services_list"
                columns={
                  hideActionsButton
                    ? columns.filter((col) => col.key !== 'actions')
                    : columns
                }
                dataSource={service}
                isLoading={isFetching}
                titleComcode="serviceList"
                onSearch={(values) => {
                  setIsFirst(true);
                  setSearchParams(values);
                }}
                initialSearchValues={initialSearchParams}
                hideExtraAction={hideAddButton ? true : false}
                extraActions={
                  <Button
                    type="primary"
                    disabled={isNewItemInTable}
                    icon={<PlusOutlined />}
                    comcode="add"
                    onClick={() =>
                      history.push('/configuration/service/create')
                    }
                  />
                }
              />
            );
          }}
        </Form.Item>
      </Form>
    </DF.Provider>
  );
};

const INITIAL_VALUES = {
  service: [],
};

export default ServiceListTable;
